import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueLazyload from 'vue-lazyload'
import { initializeSiteLanguage } from './utils/site-language'
import '../public/static/js/marketing-tracking.js'

// CSS样式已在public/index.html中引用
// import './assets/css/global.css'

async function bootstrap() {
  await initializeSiteLanguage()

  const app = createApp(App)
  app.use(router)
  app.use(VueLazyload, {
    preLoad: 1.3,
    error: '',
    loading: '',
    attempt: 1
  })
  app.mount('#app')
}

bootstrap()
